import React from "react";
import TaskposterUtil from './taskposter_util'
import Modal from "../../cmpts/modal";
import Message from "../../cmpts/ant/Message";
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from "antd";

let MODIFY_SPROGRAM = {
    target: null,
    doit: false
};

let des = {
    marginTop: '10px'
};

export class ModifySProgram {

    static initSProgramEvent() {
        $(".SPROGRAM").unbind('click');
        $(".SPROGRAM").click(function (e) {
            e.preventDefault();
            MODIFY_SPROGRAM = {
                doit: true,
                target: $(this)
            };
            $("#insertSProgram .mxd-modal-header h4").html('修改小程序');
            Modal.show("#insertSProgram")
            var text = $(this).html();
            var appid = $(this).attr('data-miniprogram-appid');
            var path = $(this).attr('data-miniprogram-path');
            $("#sprogramText").val(text);
            $("#sprogramAppId").val(appid);
            $("#sprogramPage").val(path);
        })
    }
}

export class InsertSProgramModal extends React.Component {

    constructor(props) {
        super(props);
        this.init = this.init.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        $("#insertSProgram span[data-toggle='tooltip']").tooltip();
    }

    init() {
        $("#sprogramText").val('');
        $("#sprogramPage").val('');
        $("#sprogramAppId").val('');
        MODIFY_SPROGRAM = {
            doit: false,
            target: null
        };
        Modal.hide("#insertSProgram");
        $("#insertSProgram .mxd-modal-header h4").html('插入小程序');
    }

    submit() {
        var sprogramText = $("#sprogramText").val();
        if (sprogramText.length == 0) {
            Message.warning("请输入小程序链接文本");
            $("#sprogramText").focus();
            return;
        }
        var sprogramAppId = $("#sprogramAppId").val();
        if (sprogramAppId.length == 0) {
            Message.warning("请输入小程序appid");
            $("#sprogramAppId").focus();
            return;
        }
        var sprogramPage = $("#sprogramPage").val();
        if (sprogramPage.length == 0) {
            Message.warning("请输入小程序跳转地址");
            $("#sprogramPage").focus();
            return;
        }
        sprogramAppId = $.trim(sprogramAppId);
        sprogramPage = $.trim(sprogramPage);
        if (MODIFY_SPROGRAM.doit) {
            MODIFY_SPROGRAM.target.html(sprogramText);
            MODIFY_SPROGRAM.target.attr('data-miniprogram-appid', sprogramAppId);
            MODIFY_SPROGRAM.target.attr('data-miniprogram-path', sprogramPage);
        } else {
            var targetAreaId = $("#insertSProgram").attr('targetArea');
            var SPROGRAM_ITEM = '<span class="tpmsgend"></span><a id="SPROGRAM" data-miniprogram-path="' + sprogramPage + '" data-miniprogram-appid="' + sprogramAppId + '" contenteditable="false" class="cursor-pointer SPROGRAM">' + sprogramText + '</a><span class="tpmsgend"></span>';
            var span = document.createElement("a");
            span.innerHTML = sprogramText
            span.setAttribute('data-miniprogram-path', sprogramPage);
            span.setAttribute('data-miniprogram-appid', sprogramAppId);
            span.setAttribute('id', 'SPROGRAM');
            span.setAttribute('class', 'cursor-pointer SPROGRAM');
            span.setAttribute('contenteditable', 'false');
            TaskposterUtil.insertTextItem_(targetAreaId, SPROGRAM_ITEM, span);
            ModifySProgram.initSProgramEvent();
        }
        this.init();
    }

    render() {
        return (
            <div className="mxd-modal" id="insertSProgram">
                <div className="mxd-modal-header">
                    <h4>插入小程序</h4>
                    <span className="close" onClick={this.init}></span>
                </div>
                <div className="mxd-modal-body mxd-form">
                    <div className="mxd-form-item">
                        <div className="mxd-form-title">
                            <label>小程序链接文本</label>
                            <Tooltip title='用户点击该段文本跳转到小程序'>
                                <QuestionCircleOutlined className="question" />
                            </Tooltip>
                        </div>
                        <input id="sprogramText" ref="sprogramText" type="text"
                               autoComplete="off"
                               className="mxd-input form-control"/>
                    </div>
                    <div className="mxd-form-item">
                        <div className="mxd-form-title">
                            <label>小程序appid</label>
                        </div>
                        <input id="sprogramAppId" ref="sprogramAppId" type="text"
                               autoComplete="off"
                               className="mxd-input form-control"/>
                    </div>
                    <div className="mxd-form-item">
                        <div className="mxd-form-title">
                            <label>小程序跳转路径</label>
                        </div>
                        <input id="sprogramPage" ref="sprogramPage" type="text" autoComplete="off"
                               className="mxd-input form-control"/>
                    </div>
                </div>
                <div className="mxd-modal-footer-space"></div>
                <div className="mxd-modal-footer">
                    <button type="button" className="mxd-btn mxd-btn-primary" onClick={this.submit}>确定
                    </button>
                    <button type="button" className="mxd-btn mxd-btn-cancel" onClick={this.init}>取消</button>
                </div>
            </div>
        );
    }
}